import { query, updateUser } from './api';

import { Action } from 'redux';
import { ThunkDispatch } from '.';

// Types

export interface BindingsState {
  boundDevices: DeviceData[]
  deviceBindingType: string
  deviceBindingLabel: string
}

export interface DeviceData {
  bindingType: "HARD_BIND"
  lookupLabel: string
}

// Initialization

const initialState: BindingsState = {
  boundDevices: [] as DeviceData[],
  deviceBindingType: "",
  deviceBindingLabel: ""
}

// Action Definition

export const BINDINGS_LOAD = 'bindings/LOAD'
export const BINDINGS_UNBIND_ALL = 'bindings/UNBIND_ALL'

interface BindingsLoadAction extends Action {
  type: typeof BINDINGS_LOAD,
  boundDevices: any,
  deviceBindingType: string
  deviceBindingLabel: string
}

interface BindingsUnbindAllAction extends Action {
  type: typeof BINDINGS_UNBIND_ALL,
}


// Reducer

export default (state:BindingsState = initialState, action: Action) => {
  switch (action.type) {
    case BINDINGS_LOAD:
      let loadAction = action as BindingsLoadAction
      return {
        ...state,
        boundDevices: _.castArray(loadAction.boundDevices) as DeviceData[],
        deviceBindingType: loadAction.deviceBindingType,
        deviceBindingLabel: loadAction.deviceBindingLabel
      }
    case BINDINGS_UNBIND_ALL:
      return {
        ...state,
        boundDevices: [],
        deviceBindingType: "",
        deviceBindingLabel: ""
      }
    default:
      return state
  }
}

// Action Creators

export const bind = (deviceLabel: string) =>
  (dispatch: ThunkDispatch) => {
    let args = {
      deviceManagementRequest: {
        actionTypeList: {
          deviceActionTypes: "UPDATE_DEVICE"
        },
        deviceData: {
          bindingType: 'HARD_BIND',
          newLabel: deviceLabel
        }
      }
    }

    return dispatch(updateUser(args)).then((data: any) => {
      let statusCode = _.get(data, 'deviceManagementResponse.callStatus.statusCode', "")

      if(statusCode==="SUCCESS") {
        return true
      }
      else
        throw Error("Device binding failed")
    }).catch((error: Error) => {
      console.error(error)
      throw error
    })
  }

  export const renameBinding = (lookupLabel: string, newLabel: string) =>
  (dispatch: ThunkDispatch) => {
    let args = {
      deviceManagementRequest: {
        actionTypeList: {
          deviceActionTypes: "UPDATE_DEVICE"
        },
        deviceData: {
          bindingType: 'HARD_BIND',
          lookupLabel,
          newLabel
        }
      }
    }

    return dispatch(updateUser(args)).then((data: any) => {
      let statusCode = _.get(data, 'deviceManagementResponse.callStatus.statusCode', "")

      if(statusCode==="SUCCESS") {
        return true
      }
      else
        throw Error("Rename device binding failed")
    }).catch((error: Error) => {
      console.error(error)
      throw error
    })
  }

export const loadDeviceBindings = () =>
  (dispatch: ThunkDispatch) => {
    let args = {
      deviceManagementRequest: {
        actionTypeList: {
          deviceActionTypes: "BROWSE_DEVICES"
        },
      }
    }

    return dispatch(query(args)).then((data: any) => {
      dispatch({
        type: BINDINGS_LOAD,
        boundDevices: _.get(data, 'deviceManagementResponse.deviceData', []),
        deviceBindingType: _.get(data, 'deviceResult.deviceData.bindingType', "NONE"),
        deviceBindingLabel: _.get(data, 'deviceResult.deviceData.lookupLabel', "")
      } as BindingsLoadAction)
      return data
    }).catch((error: Error) => {
      console.error(error)
      throw error
    })
  }

export const unbindAllDevices = () =>
  (dispatch: ThunkDispatch) => {
    let args = {
      deviceManagementRequest: {
        actionTypeList: {
          deviceActionTypes: "UNBIND_ALL_DEVICES"
        },
      }
    }

    return dispatch(updateUser(args)).then((data: any) => {
      dispatch({
        type: BINDINGS_UNBIND_ALL,
      } as BindingsUnbindAllAction)
      return data
    })
  }

export const unbind = (lookupLabel: string) =>
  (dispatch: ThunkDispatch) => {
    let args = {
      deviceManagementRequest: {
        actionTypeList: {
          deviceActionTypes: "UPDATE_DEVICE"
        },
        deviceData: {
          bindingType: 'NONE',
          lookupLabel
        }
      }
    }

    return dispatch(updateUser(args)).then((data: any) => {
      dispatch({
        type: BINDINGS_UNBIND_ALL,
      } as BindingsUnbindAllAction)
      return data
    })
  }